import type { TFunction } from 'i18next';
import type { RestockItem } from '../../src/lib/restock';

/** "Due in 3 days", "Due today", "2 days overdue". */
export const restockDueText = (t: TFunction, item: RestockItem): string => {
  const d = item.daysUntilDue;
  if (d === 0) return t('restock.due_today', { defaultValue: 'Due today' });
  if (d > 0) return t('restock.due_in', { count: d, defaultValue: 'Due in {{count}} days' });
  return t('restock.overdue', { count: -d, defaultValue: '{{count}} days overdue' });
};

/** "Every ~9 days". */
export const restockEveryText = (t: TFunction, item: RestockItem): string =>
  t('restock.every', { count: item.intervalDays, defaultValue: 'Every ~{{count}} days' });

export const restockConfidenceText = (t: TFunction, item: RestockItem): string =>
  item.confidence === 'high'
    ? t('restock.confidence_high', { defaultValue: 'Steady rhythm' })
    : item.confidence === 'medium'
    ? t('restock.confidence_medium', { defaultValue: 'Fairly regular' })
    : t('restock.confidence_low', { defaultValue: 'Early estimate' });

/** Overdue or due within 3 days. */
export const isRestockUrgent = (item: RestockItem) => item.daysUntilDue <= 3;
